import { Box, Button, Flex, HStack } from "@chakra-ui/react";
// import { ExportToPDFButton } from "@/components/tiptap/custom-ui/ExportToPDFButton"


export function MenuBar({ }: { editor: any }) {
  return (
    <Box height="40px" width="100%" bg="bg.option1" borderRadius={12} px={4}>
      <Flex height="100%" alignItems="center" justifyContent="space-between">
        {/* Left column */}
        <HStack gap={4}>
          <Button variant="ghost" size="sm">
            파일
          </Button>
          <Button variant="ghost" size="sm">
            포맷
          </Button>
          <Button variant="ghost" size="sm">
            툴
          </Button>
        </HStack>

        {/* Right column */}
        <HStack gap={4}>
          {/* <ExportToPDFButton editor={editor}/> */}
          {/* <Button variant="ghost" size="sm">
            Export to PDF
          </Button> */}
        </HStack>
      </Flex>
    </Box>
  );
}
